<div class="widget-loader">
    <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden"></span>
    </div>
</div>
